/* eslint-disable import/extensions */
import 'vanilla-ripplejs'
import './frontend.scss'
import './vue/swiper-plugin'
import './vue/vee-validate'
import './vue/filters'
import './vue/vue-router'

import common from './routes/common'
import home from './routes/home'
import taxProductCat from './routes/productCat'
import serviceBooking from './routes/serviceBooking'
import contactUs from './routes/contact'
import postTypeArchiveCustomer from './routes/customer'
import singleCustomer from './routes/customerSingle'
import singleProduct from './routes/singleProduct'

import Router from './util/Router'
// import 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js'
// require('https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js')
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const singlePost = singleCustomer
const singlePromotion = singleCustomer
const routes = new Router({
  common,
  home,
  taxProductCat,
  // postTypeArchiveProduct,
  // singleProduct,
  // postTypeArchiveCertificate,
  contactUs,
  // aboutUs,
  serviceBooking,
  postTypeArchiveCustomer,
  singleCustomer,
  singlePost,
  singleProduct,
  singlePromotion,
})

window.addEventListener('DOMContentLoaded', () => {
  routes.loadEvents()
})
